document.querySelectorAll('.hall').forEach(function (root) {
  var swatches = root.querySelectorAll('[data-hall-swatch]');
  var panels = root.querySelectorAll('[data-hall-panel]');

  if (!('IntersectionObserver' in window) || !panels.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        swatches.forEach(function (swatch) {
          swatch.classList.toggle(
            'is-active',
            swatch.getAttribute('data-hall-swatch') === entry.target.id
          );
        });
      });
    },
    { rootMargin: '-50% 0px -49% 0px', threshold: 0 }
  );

  panels.forEach(function (panel) {
    observer.observe(panel);
  });
});
